import { APICore } from './apiCore';

const api = new APICore();

// account
function login(params: { email: string; password: string }) {
    //const baseUrl = '/login/';
    const baseUrl = '/users/token';
    let  c=api.createLogin(`${baseUrl}`, params)    
    return c
}

// account
function loginWithCode(params: { email: string; password: string, code:string }) {
    //const baseUrl = '/login/';
    const baseUrl = '/users/tokenWithCode';
    let  c=api.createLogin(`${baseUrl}`, params)    
    return c
}

// SSO
function loginWithSso(params: { token: string }) {
    const baseUrl = '/users/SsoLogin';
    return api.createSsoLogin(`${baseUrl}`, params);
}

function logout() {
    const baseUrl = '/users/logout';
    return api.create(`${baseUrl}`, {});
}

function signup(params: { fullname: string; email: string; password: string }) {
    const baseUrl = '/register/';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: { email: string }) {
    const baseUrl = '/forget-password/';
    return api.create(`${baseUrl}`, params);
}

export { login,loginWithCode, logout, signup, forgotPassword,loginWithSso };
